import React from 'react';
import TextComponent from 'shared/components/TextComponent';

const StencilFrameType = (props) => {
  const name = 'frame_type';

  const {
    label,
    inputId,
    required,
    groupName,
    children,
    parameters,
    onChangeParameter,
    errorMessage,
    tooltip,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <TextComponent
      label={label}
      name={name}
      inputId={inputId}
      value={parameters[name] || ''}
      required={required}
      onChange={onChange}
      tooltip={tooltip}
      ignoreOnQuote
      groupName={groupName}
      errorMessage={errorMessage}>
      {children}
    </TextComponent>
  );
};

StencilFrameType.defaultProps = {
  required: true,
  inputId: 'frame-type',
  label: Spree.translations.parameters.frame_type,
  tooltip: Spree.helpForParameters.frame_type,
};

export default StencilFrameType;